import store_config from "@/store/mods/parametres/config";
import ListeModeleExamen from "@/views/parametres/configs/param-modele-examen/liste-modele-examens"
import ListeChampsModeleExamen from "@/views/parametres/configs/param-modele-examen/liste-champs-modele-examen"

export default {
    name: 'param-modele-examen',
    components: {
        ListeModeleExamen, ListeChampsModeleExamen
    },
    props: {
        user_info: Object
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_error: '',
            type_examens: [],
            fields: [
				{ key: 'examen', label: 'Type examen' }, { key: 'actions', label: 'Action.s' }
			],
			filter: "",
			perPage: 50,
			currentPage: 1,
            curr_comp: 'liste-examens',
            selected_examen: {},
            selected_modele: {}
        }
    },

    computed: {
        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        this.getListeExamens()
    },

    methods: {
        getListeExamens() {
            this.is_loading = true
            this.is_error = false

            store_config.getListeTypeExamens().then((response) =>{
                this.type_examens = response
                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        configurer(examen) {
            this.selected_examen = examen
            this.goToComp('liste-modele-examens')
        },

        goToComp(goto_comp) {
            this.curr_comp = goto_comp
        },

        setSelectedModele(modele) {
            console.log(modele);
            this.selected_modele = modele
        },

        setPageToGo(info) {
            this.selected_fiche = info.fiche_data
            this.goTo(info.go_to_page)
        },
    }
}